import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María F.', 'Sofía L.', 'Valentina G.', 'Camila R.', 'Lucía M.', 'Ana P.', 'Julieta S.', 'Martina B.', 'Paula D.', 'Florencia T.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    // Loop
    const interval = setInterval(() => {
      showNotification();
    }, 15000 + Math.random() * 10000); // Random interval between 15-25s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const showNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  };
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: 0
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full bg-white rounded-lg shadow-lg border-l-4 border-purple-400 p-4 flex items-center gap-3" data-id="element-2">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-3">
            <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-4" />
          </div>
          <div data-id="element-5">
            <p className="text-sm font-medium text-gray-900" data-id="element-6">
              <span className="font-bold" data-id="element-7">{data.name}</span> de {data.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-8">
              compró{' '}
              <span className="font-semibold text-purple-600" data-id="element-9">
                Sanar Sin Culpa
              </span>
            </p>
            <p className="text-[10px] text-gray-400 mt-0.5" data-id="element-10">
              hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}